module.exports = __webpack_public_path__ + "static/media/vivo-home-s1.24e0382f.svg";